import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private error = new BehaviorSubject<boolean>(false);
  public error$ = this.error.asObservable();

  setData(value: boolean): void {
    this.error.next(value);
  }
}
